<!-- Institute of Design and Innovation (email idi@unm.edu). -->

<!-- Log user out -->
<template>
  <div class="logged-out">
    <h3>You have been signed out</h3>
  </div>
</template>

<script>
export default {
  name: 'Signed Out'
}
</script>

<style lang="scss" scoped>
  .logged-out h3 {
    display: block;
    width: 100%;
    text-align: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
</style>
